import type { EffectParams } from '@swf/core/store';

const acceptLiveRacesTerms = async (payload: undefined, { dispatch, request }: EffectParams) => {
  try {
    await request({ service: 'casino.races.acceptLDR' });
    dispatch.modal.close('/casino/help');
    dispatch.casino.set({ liveRacesTermsAccepted: true });
  } catch (err) {
    dispatch.modal.close('/casino/help');
  }
};

export default acceptLiveRacesTerms;
